import sanitizeHtml from "sanitize-html";

const sanitizationOptions = {
  allowedTags: [
    "a",
    "blockquote",
    "br",
    "div",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "iframe",
    "img",
    "li",
    "ol",
    "p",
    "section",
    "span",
    "table",
    "tbody",
    "td",
    "th",
    "thead",
    "tr",
    "ul",
  ],
  alwaysAllowedAttributes: ["class", "target"],
  allowedAttributesPerTag: {
    img: ["src", "alt"],
    iframe: ["src", "width", "height", "style"],
    a: ["data-*", "href", "rel"],
  },
  get allowedAttributes() {
    return this.allowedTags.reduce(
      (obj, tag) => ({
        ...obj,
        [tag]: this.alwaysAllowedAttributes.concat(
          this.allowedAttributesPerTag[
            tag as keyof typeof this.allowedAttributesPerTag
          ] || []
        ),
      }),
      {}
    );
  },
};

const sanitizeDom = (dirtyContent: string): string => {
  const {allowedTags, allowedAttributes} = sanitizationOptions;

  return sanitizeHtml(dirtyContent, {
    allowedTags,
    allowedAttributes,
    allowedIframeHostnames: [
      "www.youtube.com",
      "fast.wistia.net",
      "public.tableau.com",
    ],
    allowedIframeDomains: [
      "ctfassets.net",
      "hackerone.com",
      "tech.flexport.com",
    ],
  });
};

export default sanitizeDom;
